// widgets/chart/ui/Legend.tsx
import styled from "styled-components";
import { LegendItem } from "widgets/chart/model/types";

const Wrap = styled.div`
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    color: var(--fg-muted, rgba(16, 24, 40, 0.55));
    font-size: 12px;
    line-height: 16px;
    justify-content: center;
    gap: 20px;
    height: max-content;
    row-gap: 5px;
    margin-top: 5px;
`;

const Dot = styled.span<{ color: string }>`
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: ${({ color }) => color};
    display: inline-block;
    flex-shrink: 0;
`;

const Item = styled.div`
    display: flex;
    gap: 6px;
    align-items: center;
`;

type ExtendedLegendItem = LegendItem & { ts?: number; unit?: "hour" | "day" | "week" | "month" };

type Props = {
    items: ExtendedLegendItem[];
    className?: string;
};

function formatHourLegend(ts: number) {
    const d = new Date(ts);
    const now = new Date();
    const isToday =
        d.getFullYear() === now.getFullYear() &&
        d.getMonth() === now.getMonth() &&
        d.getDate() === now.getDate();
    const time = d.toLocaleTimeString("ru-RU", { hour: "2-digit", minute: "2-digit" });
    if (isToday) return time;
    const date = d.toLocaleDateString("ru-RU", { day: "numeric", month: "long" });
    return `${date} в ${time}`;
}

function renderLabel(l: ExtendedLegendItem) {
    if (l.unit === "hour" && typeof l.ts === "number") {
        return formatHourLegend(l.ts);
    }
    return l.label;
}

export const ChartLegend = ({ items, className }: Props) => {
    if (!items || items.length === 0) return null;
    return (
        <Wrap className={className}>
            {items.map((l, i) => (
                <Item key={i}>
                    <Dot color={l.color} />
                    <span>{renderLabel(l)}</span>
                </Item>
            ))}
        </Wrap>
    );
};
